import { Injectable, inject } from "@angular/core";
import {Router} from "@angular/router";
import {EMissionDetailSegment} from "@tech/pages/inventory/pages/mission-detail/enums/mission-detail-segment.emun";

@Injectable({
  providedIn: 'root',
})
export class TechInventoryMissionPagesService {
  private _router = inject(Router);


  private _selectedSegment = EMissionDetailSegment.MISSION;

  set selectedSegment(userSelection: EMissionDetailSegment) {
    this._selectedSegment = userSelection;
  }

  get selectedSegment() {
    return this._selectedSegment;
  }

  resetSegment() {
    this.selectedSegment = EMissionDetailSegment.MISSION;
  }

  changeSegmentSetting(currentSegment?: EMissionDetailSegment): void {
    const currentUrl = this._router.url;
    const urlSegments = currentUrl.split('/');
    const idIndex = urlSegments.findIndex(segment => segment === 'mission') + 1;
    const id = urlSegments[idIndex];
    let targetRoute = '';

    if (!id) {
      this._router.navigate([`/tech/logged/inventory`]);
    } else {
      switch (currentSegment) {
        case EMissionDetailSegment.MISSION:
          this.selectedSegment = EMissionDetailSegment.MISSION;
          targetRoute = `/tech/logged/inventory/mission/${ id }/view`;
          break;
        case EMissionDetailSegment.CHAT:
          this.selectedSegment = EMissionDetailSegment.CHAT;
          targetRoute = `/tech/logged/inventory/mission/${ id }/chat`;
          break;
        case EMissionDetailSegment.REPORT:
          this.selectedSegment = EMissionDetailSegment.REPORT;
          targetRoute = `/tech/logged/inventory/mission/${ id }/report`;
          break;
        case EMissionDetailSegment.SOLUTION:
          this.selectedSegment = EMissionDetailSegment.SOLUTION;
          targetRoute = `/tech/logged/inventory/mission/${ id }/solution`;
          break;
        default:
          this.selectedSegment = EMissionDetailSegment.MISSION;
          targetRoute = `/tech/logged/inventory/mission/${ id }/view`;
          break;
      }
      this._router.navigate([targetRoute]);
    }
  }

  getSegmentAndChecK(segment: string): EMissionDetailSegment | undefined {
    switch (segment) {
      case 'view':
        return EMissionDetailSegment.MISSION
      case 'chat':
        return EMissionDetailSegment.CHAT
      case 'report':
        return EMissionDetailSegment.REPORT
      case 'solution':
        return EMissionDetailSegment.SOLUTION
      default:
        return undefined
    }
  }
}
